import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import Home from './components/Home/Home';
import { OrderGuide } from './components/OrderGuide/OrderGuide';
import { CreateSalesOrder } from './components/SalesOrder/CreateSalesOrder';
import { SODashboard } from './components/SODashboard';
import { Analytics } from './components/Analytics/Analytics';
import Users from './components/Admin/Users';
import { ResetPassword } from './components/Login/ResetPassword';
import { ForgotPassword } from './components/Login/ForgotPassword';
import Login from './components/Login/Login';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import OrderGuideGroup from './components/Admin/OrderGuideGroup';
import { UserRoles } from './components/shared/enums';
import { SOHistory } from './components/Report/SOHistory';
import CreateSalesOrderGroup from './components/SalesOrderGroup/CreateSalesOrderGroup';

export class App extends Component {
    displayName = App.name;

    render() {
        return (
            <Layout>
                <Route exact path='/' render={(props) => <Home {...props} isEditHome={(this.props.userRole === UserRoles.GroupStoreBuyer) ? true : false} />} />
                <Route path='/login' component={Login} />
                <Route path='/ResetPassword' component={ResetPassword} />
                <Route path='/ForgotPassword' component={ForgotPassword} />

                {this.props.isAuthenticated && (this.props.userRole === UserRoles.Administrator || this.props.userRole === UserRoles.SalesRep) &&
                    <React.Fragment>
                        <Route path='/Home/Edit' render={(props) => <Home {...props} isEditHome />} />
                        <Route path='/Analytics' component={Analytics} />
                        <Route path='/Admin/Users' component={Users} />
                        <Route path='/Admin/OrderGuideGroup' component={OrderGuideGroup} />
                        <Route path='/OrderGuide' component={OrderGuide} />
                        <Route path='/SODashboard' component={SODashboard} />
                    </React.Fragment>
                }
                {this.props.isAuthenticated && (this.props.userRole === 'GroupStoreBuyer' || this.props.userRole === 'StoreBuyer' || this.props.userRole ==='SalesRep') &&
                    <React.Fragment>
                        <Route path='/CreateSalesOrder' render={(props) => <CreateSalesOrder {...props} isSameDay={false} />} />
                        <Route path='/CreateSameDaySalesOrder' render={(props) => <CreateSalesOrder {...props} isSameDay />} />
                    </React.Fragment>
                }
                {this.props.isAuthenticated && (this.props.userRole === 'GroupStoreBuyer' || this.props.userRole === 'StoreBuyer') &&
                    <React.Fragment>
                    <Route path='/Report/SOHistory' component={SOHistory} />
                    </React.Fragment>
                }

                {this.props.isAuthenticated && (this.props.userRole === 'GroupStoreBuyer' || this.props.userRole === 'SalesRep') &&
                    <React.Fragment>                   
                        <Route path='/CreateSalesOrderGroup' render={(props) => <CreateSalesOrderGroup {...props} isSameDay={false} />} />                    
                    </React.Fragment>
                }
            </Layout>
        );
    }
}
export default withRouter(connect(state => state.login)(App));


// WEBPACK FOOTER //
// ./src/App.js